const tryParseJson = (value) => {
  if (typeof value !== 'string') return value;

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const normalizeOptions = (options = []) => options
  .map((option) => {
    if (typeof option === 'string') {
      return { label: option, value: option };
    }

    return {
      ...option,
      id: option?.id ?? option?.value ?? null,
      label: String(option?.label ?? option?.name ?? option?.value ?? '').trim(),
      value: String(option?.value ?? option?.id ?? option?.label ?? option?.name ?? '').trim(),
      name: option?.name ?? option?.label ?? option?.value ?? '',
      price: option?.price ?? null,
      category: option?.category ?? null,
      image: option?.image ?? null,
    };
  })
  .filter((option) => option.label && option.value);

export const parseAgentResponse = (input = '') => {
  const parsedInput = tryParseJson(input) || input;
  const responseObject = typeof parsedInput === 'object' && parsedInput !== null ? parsedInput : null;
  const rawText = typeof input === 'string'
    ? input
    : JSON.stringify(input || '');

  try {
    const messagePayload = tryParseJson(responseObject?.message) || {};
    const parsed = responseObject || messagePayload;
    const nestedPayload = responseObject ? messagePayload : {};
    const responseType = parsed?.type || nestedPayload?.action || null;

    const jsonMessage = nestedPayload?.message || parsed?.message || '';
    const jsonOptions = Array.isArray(nestedPayload?.options)
      ? nestedPayload.options
      : Array.isArray(parsed?.options)
        ? parsed.options
        : Array.isArray(parsed?.data?.desserts)
          ? parsed.data.desserts
          : [];
    const jsonNote = nestedPayload?.note || parsed?.note || parsed?.data?.note || '';

    if (jsonMessage || jsonOptions.length) {
      return {
        message: String(jsonMessage || '').trim(),
        note: String(jsonNote || '').trim(),
        type: responseType,
        suggestions: normalizeOptions(jsonOptions),
      };
    }

    if (responseType === 'drink' || responseType === 'custom_drink') {
      return {
        message: '',
        note: '',
        type: responseType,
        suggestions: [],
      };
    }
  } catch (error) {
    // Fallback to the legacy plain-text format below.
  }

  const lines = rawText
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  const suggestions = lines
    .filter((line) => line.startsWith('-'))
    .map((line) => line.replace(/^-\s*/, '').trim())
    .map((value) => ({ label: value, value }));

  const message = lines
    .filter((line) => !line.startsWith('-'))
    .join('\n')
    .trim();

  return {
    message,
    note: '',
    type: responseObject?.type || null,
    suggestions: normalizeOptions(suggestions),
  };
};
